import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
export function Guarantee() {
  return <section className="w-full bg-white px-5 py-14 sm:py-20" data-id="element-128" data-mp="20m4obp53y8tf">
      <div className="mx-auto w-full max-w-xl" data-id="element-129" data-mp="24myekp60vzph">
        <div className="flex flex-col items-center text-center" data-id="element-130" data-mp="24l3s36f3rzja">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-teal-500/12" data-id="element-131" data-mp="29eyiesp7rcrc">
            <ShieldCheckIcon className="h-7 w-7 text-teal-700" aria-hidden="true" data-id="element-132" data-mp="2ebyimmzdtlaj" />
          </span>
          <h2 className="mt-5 font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-133" data-mp="2jat827ruu83m">
            You have 7 days to see whether the Route actually simplifies your clinical practice
          </h2>
        </div>

        <div className="mt-7 space-y-4 text-[15px] leading-relaxed text-ink-900/70 sm:text-base" data-id="element-134" data-mp="2saomqmkmcl8e">
          <p data-id="element-135" data-mp="tz99zwqg129z">
            We want you to make this decision with complete peace of mind. That is why we take the
            risk.
          </p>
          <p data-id="element-136" data-mp="3slonvc6amobp">
            If, during the next 7 days, you feel that the Route does not help simplify your
            consultations or give you greater clarity when making clinical decisions, simply contact
            us and we will refund 100% of your purchase.
          </p>
          <p className="font-semibold text-ink-900" data-id="element-137" data-mp="3dwsi5lrplne9">
            No questions. No complicated process. No hidden conditions.
          </p>
        </div>

        <TransformCTA tone="light" headline="Try it for 7 days with zero risk." data-id="element-138" data-mp="feeko8alkk5r" />
      </div>
    </section>;
}